import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import InformationalModal from 'chameleon/ui-stack/ui/modals/informational-modal';
import ModalRow from './ModalRow';
import { renderDescription } from './util';

const GuideModal = (props) => {
  const { title, size, button, children, tableContent, hasTitleWithTooltip } =
    props;
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <Fragment>
      {React.cloneElement(button, { onClick: () => setIsModalOpen(true) })}
      {isModalOpen && (
        <InformationalModal
          size={size}
          title={title}
          hasTitleWithTooltip={hasTitleWithTooltip}
          onClose={() => setIsModalOpen(false)}
        >
          {children}
          {!!tableContent.length && (
            <div className="mt-4.2">
              {tableContent.map(
                ({ title: listTitle, description, highlightedText }, index) => (
                  <ModalRow
                    key={`modal-row-${index}`}
                    isHeader={index === 0}
                    isLast={index === tableContent.length - 1}
                    leftColData={listTitle}
                    rightColData={renderDescription(
                      description,
                      highlightedText,
                    )}
                  />
                ),
              )}
            </div>
          )}
        </InformationalModal>
      )}
    </Fragment>
  );
};

GuideModal.propTypes = {
  // The title of the modal
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // Sets the size of the modal
  size: PropTypes.string,
  button: PropTypes.object,
  tableContent: PropTypes.array,
  // If true the title tooltip algorithm is used to determine
  // if title needs tooltip
  hasTitleWithTooltip: PropTypes.bool,
};

GuideModal.defaultProps = {
  title: null,
  size: 'medium',
  button: null,
  tableContent: [],
  hasTitleWithTooltip: true,
};

export default GuideModal;
